import React from "react";
// components
import ContentRenderer from "@/components/ContentRenderer";
import MainPageLayouts from "@/components/MainPageLayouts";
// types
import { TMainPageLayoutV3 } from "../type";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
// enums
import EView from "@/cms/enums/EView";
import EContentType from "@/cms/enums/EContentType";
// utilities
import LanguageVersionSelector from "@/utilities/LanguageVersionSelector";
import { isEmpty } from "lodash";


type TRender = {
    languageVersions:TLanguageVersionDetail[]|TLanguageVersionList[];
}

const Render = ( props:TRender ) => {
    console.log("MNPG038.Render: ", props);

    return (
        <div className="post-content row g-4">
            <ContentRenderer languageVersions={props.languageVersions} />
        </div>
    )
}

const MNPG038 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG038.rendered: ", props);

    if ( !props.template || !props.templates || !props.params?.["contentDetails"] || isEmpty(props.params?.["contentDetails"]) ) return null;

    const languageVersion = LanguageVersionSelector<TLanguageVersionDetail[]|undefined>({
        languageVersions: props.params["contentDetails"].languageVersions,
        filters: [
            { view: EView.INNER, contentType: EContentType.DEFAULT }
        ],
        type: "filter"
    });

    const wrapper = props.templates.find((item) => item.parentId === props.template?.id);
    console.log("MNPG038.wrapper: ", wrapper);

    if ( !languageVersion || isEmpty(languageVersion) ) return null;

    if ( wrapper ) {
        const layoutName = wrapper.layouts?.[0]?.layoutName;
        const Layout = MainPageLayouts?.[layoutName as string];
        if ( Layout ) return (<Layout><Render languageVersions={languageVersion}/></Layout>);
    }

    return <Render languageVersions={languageVersion} />
}

export default MNPG038;
